//############################################################################################
//# axboot.command
//############################################################################################

axboot.command = {
    'ajax' : function (url, data, callback, isUnconditionalCallback) {
        // 20180614 (이상훈) : 순수 array 형 파라미터를 사용할 경우 문제 발생으로, data 파라미터가 array 일경우 object map 으로 머지기능 삭제.
        /*
        var tempData = {};

        if (ax5.util.getType(data) === 'array') {
            for (var i = 0; i < data.length; i++) {
                tempData = $.extend(true, tempData, data[i]);
            }
        } else if (ax5.util.getType(data) === 'object') {
            tempData = $.extend(true, tempData, data);
        }
        */

        // data 값이 없을 경우 빈 object 로 전송한다.
        if (ax5.util.isNothing(data)) {
            data = {};
        }

        axboot.ajax({
            url      : url,
            data     : JSON.stringify(data), 
            callback : function (res) {
                if (!ax5.util.isNothing(callback) && ax5.util.getType(callback) === 'function') {
                    callback.call(this, res);
                }
            },
            unconditionalCallback : isUnconditionalCallback
        });
    },
    'get' : function (obj, options, callback) {
        var ajaxConfig = axboot.util.getCommandOptionsToAjaxConfig(options);
        var objList = [];

        if (ax5.util.getType(obj) === 'object') {
            objList.push(obj);
        } else if (ax5.util.getType(obj) === 'array') {
            objList = obj;
        }

        for (var i = 0; i < objList.length; i++) {
            if (objList[i].target.name == 'grid') {
                ajaxConfig['data'] = $.extend(true, {}, ajaxConfig['data'], objList[i].getPageData());
            }
        }
        
        axboot.ajax({
            url      : ajaxConfig['url'],
            data     : JSON.stringify(ajaxConfig['data']), 
            callback : function (res) {
                if (!ax5.util.isNothing(callback) && ax5.util.isFunction(callback)) {
                    callback.call(this, res);
                } else {
                    for (var i = 0; i < objList.length; i++) {
                        var data = ax5.util.deepCopy(res);

                        objList[i].setData(data);

                        // 바인딩된 폼을 초기화 시켜준다.
                        var aryBindingTarget = axboot.util.getBindingTargets(objList[i].target.$target);

                        for (var x = 0; x < aryBindingTarget.length; x++) {
                            if (fnObj.hasOwnProperty(aryBindingTarget[x])) {
                                fnObj[aryBindingTarget[x]].disable();
                                fnObj[aryBindingTarget[x]].setData(fnObj[aryBindingTarget[x]].getDefaultData());
                            }
                        }
                    }
                }
            }
        });
    },
    'save' : function (obj, options, callback) {
    	var mask = new ax5.ui.mask();
        var objectType = axboot.util.getObjectType(obj);

        // todo : 다중 객체가 들어올 경우의 처리
        if (ax5.util.getType(obj) === 'object') {

        } else if (ax5.util.getType(obj) === 'array') {

        }
       
        var ajaxConfig = {
            'saveAll' : false
        };

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        // GRID 일 경우 처리
        if (objectType == 'GRID') {
            var list = obj.getData();
   
            var commandList = [];
            var message = '';
            
            // 전체 저장일 경우 : rowState 를 'U' (수정) 으로 변경한다.
            if (ajaxConfig['saveAll']) {
                for (var i = 0; i < list.length; i++) {
                    list[i]['rowState'] = 'U';
                    commandList.push(list[i]);
                }
            } else {
                for (var i = 0; i < list.length; i++) {           	
                    if (axboot.util.isSaveRow(list[i])) {
                    	
                        list[i]['rowState'] = axboot.util.getRowState(list[i]);
                        commandList.push(list[i]);
                    }
                }
            }
            // 저장시킬 목록이 존재할 경우
            if (commandList.length > 0) {
                ajaxConfig['data'] = commandList;
              
                if(message != ''){ 
	                axDialog.confirm({
	                    theme : 'danger',
	                    title : '알림!',
	                    msg   : message,
	                    onStateChanged: function () {
	                        if (this.state === 'open') {
	                            mask.open({theme: 'danger'});
	                        }
	                        else if (this.state === 'close') {
	                            mask.close();
	                        }
	                    }
	                }, function () {
	                    if (this.key == 'ok') {
	                        axboot.ajax({
	                            url      : ajaxConfig['url'],
	                            data     : JSON.stringify(ajaxConfig['data']),
	                            callback : callback
	                        });
	                    }
	                });
                
                } else {
	                axboot.ajax({
	                    url      : ajaxConfig['url'],
	                    data     : JSON.stringify(ajaxConfig['data']),
	                    callback : callback
	                });
            	}
            } else {
                axDialog.alert({
                    title : '알림',
                    msg   : '저장 대상이 없습니다.'
                });
            }
        }
        // 폼 일 경우 처리
        else if (objectType == 'FORM') {
            axboot.ajax({
                url      : ajaxConfig['url'],
                data     : JSON.stringify(obj.getData()),
                callback : callback
            });
        }
        else {
            // 20190422 (이상훈) : Object 객체를 이용하여 GRID 데이터를 넘길 경우 caller.gird 를 설정해줘야 한다.
            // !!caller.grid.getData 를 직접 설정할 경우 objectType 을 알수 없음.
            /*
            var objParam = {};
            objParam.crqfcList    = caller.crqfcGrid;
            objParam.lantraList   = caller.lantraGrid;
            objParam.ovseaExpList = caller.ovseaExpGrid;
            objParam.actHstList   = caller.acthstGrid;
            */

            for (var key in obj) {
                objectType = axboot.util.getObjectType(obj[key]);

                if (objectType === 'GRID') {
                    var list = obj[key].getData();

                    for (var i = 0; i < list.length; i++) {
                        if (axboot.util.isSaveRow(list[i])) {
                            list[i]['rowState'] = axboot.util.getRowState(list[i]);
                        }
                    }

                    obj[key] = list;
                }
            }

            axboot.ajax({
                url      : ajaxConfig['url'],
                data     : JSON.stringify(obj),
                callback : callback
            });
        }
    },
    'remove' : function (obj, options, callback) {
        var objectType = axboot.util.getObjectType(obj);

        var defaultParam = {};
        var ajaxConfig = {};
        var message = '';
        var selectedCount = 0;

        // todo : 다중 객체가 들어올 경우의 처리
        if (ax5.util.getType(obj) === 'object') {

        } else if (ax5.util.getType(obj) === 'array') {

        }

        if (objectType == 'GRID') {
            selectedCount = obj.getData('selected').length;
        }

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        if (selectedCount == 0) {
            axDialog.alert({
                title : '알림',
                msg   : '삭제 대상이 없습니다.'
            });

            return;
        }

        var hasAddRow = false;
        var list = obj.getData();
        var commandList = [];
        var rtnMessage = '';
        
        for (var i = (list.length - 1); i >= 0 ; i--) {
            /* 2010.12.06 (이상훈) : 신규 입력행이면서 선택되었을 경우에만 확인 */
            if (axboot.util.getRowState(list[i]) == 'I' && axboot.util.isSelectedRow(list[i])) {
                hasAddRow = true;
                break;
            }
        }

        if (hasAddRow) {
            axDialog.confirm({
                theme : 'danger',
                title : '삭제 알림!',
                msg   : '신규 입력된 항목중 선택된 항목을 삭제 하시겠습니까?',
                width : 400
            }, function () {
                if (this.key == 'ok') {
                    for (var i = (list.length - 1); i >= 0 ; i--) {
                        if (list[i]['__created__'] && list[i]['__selected__']) {
                            obj.target.deleteRow(i);
                        }
                    }

                    obj.target.focus('END');
                }
            });
        } else {
            var mask = new ax5.ui.mask();
            var targetValue = '';

            if (objectType == 'GRID') {
                var columns = obj.target.columns;
                var targetColumnKeys = [];
                var targetColumnValues = [];
                var messageLimitCount = 5;
                var selectedData;
                var hasCommandMessage = false;

                // 재귀호출
                var commandMessageFind = function (columns) {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].hasOwnProperty('commandMessage') && columns[i]['commandMessage'] == 'remove') {
                            targetColumnKeys.push(columns[i]['key']);
                            hasCommandMessage = true;
                        }

                        if (columns[i].hasOwnProperty('columns')) {
                            commandMessageFind(columns[i]['columns']);
                        }
                    }
                }

                // 메시지 출력 대상 값이 있는지 확인한다.
                /*
                for (var i = 0; i < columns.length; i++) {
                    if (columns[i].hasOwnProperty('commandMessage') && columns[i]['commandMessage'] == 'remove') {
                        targetColumnKeys.push(columns[i]['key']);
                        hasCommandMessage = true;
                    }
                }
                */

                commandMessageFind(columns);

                if (hasCommandMessage) {
                    for (var i = 0; i < selectedCount; i++) {
                        if (i > (messageLimitCount - 1)) {
                            break;
                        }

                        targetValue = '';

                        for (var j = 0; j < targetColumnKeys.length; j++) {
                            selectedData = obj.getData('selected')[i][targetColumnKeys[j]];

                            if (ax5.util.isNothing(selectedData)) {
                                selectedData = '';
                            }

                            if (j > 0 && !ax5.util.isNothing(selectedData)) {
                                targetValue += ', ';
                            }

                            targetValue += selectedData;
                        }

                        targetColumnValues.push(targetValue);
                    }
                }
            }

            message = ' 선택된 <font color="red"><b>' + selectedCount + '</b></font> 개의 항목을 삭제하시겠습니까?';
            if(rtnMessage != '' ) message = rtnMessage + '<br />' + message;
            
            for (var i = 0; i < targetColumnValues.length; i++) {
                message += '<br />';
                message += '[' + targetColumnValues[i] + ']';
            }

            if (hasCommandMessage && (selectedCount - messageLimitCount) > 0) {
                message += '<br />';
                message += '외 <font color="red"><b>' + (selectedCount - messageLimitCount) + '</b></font> 개';
            }

            axDialog.confirm({
                theme : 'danger',
                title : '삭제 알림!',
                msg   : message,
                onStateChanged: function () {
                    if (this.state === 'open') {
                        mask.open({theme: 'danger'});
                    }
                    else if (this.state === 'close') {
                        mask.close();
                    }
                }
            }, function () {
                if (this.key == 'ok') {
                    for (var i = (list.length - 1); i >= 0 ; i--) {
                        if (axboot.util.isSelectedRow(list[i])) {
                            list[i]['rowState'] = 'R';
                            commandList.push(list[i]);
                        }
                    }

                    if (commandList.length > 0) {
                        ajaxConfig['data'] = commandList;

                        axboot.ajax({
                            url      : ajaxConfig['url'],
                            data     : JSON.stringify(ajaxConfig['data']),
                            callback : callback
                        });
                    }
                }
            });
        }
    },
    'select' : function (obj, options, callback) {
        var objectType = axboot.util.getObjectType(obj);

        var defaultParam = {};
        var ajaxConfig = {};
        var message = '';
        var selectedCount = 0;

        // todo : 다중 객체가 들어올 경우의 처리
        if (ax5.util.getType(obj) === 'object') {

        } else if (ax5.util.getType(obj) === 'array') {

        }

        if (objectType == 'GRID') {
            selectedCount = obj.getData('selected').length;
        }

        if (ax5.util.getType(options) === 'string') {
            ajaxConfig['url'] = options;
        } else if (ax5.util.getType(options) === 'object') {
            ajaxConfig = $.extend(true, {}, ajaxConfig, options);
        }

        if (selectedCount == 0) {
            axDialog.alert({
                title : '알림',
                msg   : '선택 대상이 없습니다.'
            });

            return;
        }

        var hasAddRow = false;
        var list = obj.getData();
        var commandList = [];
        var rtnMessage = '';
        
        for (var i = (list.length - 1); i >= 0 ; i--) {
            if (axboot.util.getRowState(list[i]) == 'I') {
                hasAddRow = true;
                break;
            }
        }

        if (hasAddRow) {
            axDialog.confirm({
                theme : 'danger',
                title : '삭제 알림!',
                msg   : '신규 입력된 항목중 선택된 항목을 삭제 하시겠습니까?',
                width : 400
            }, function () {
                if (this.key == 'ok') {
                    for (var i = (list.length - 1); i >= 0 ; i--) {
                        if (list[i]['__created__'] && list[i]['__selected__']) {
                            obj.target.deleteRow(i);
                        }
                    }

                    obj.target.focus('END');
                }
            });
        } else {
            var mask = new ax5.ui.mask();
            var targetValue = '';

            if (objectType == 'GRID') {
                var columns = obj.target.columns;
                var targetColumnKeys = [];
                var targetColumnValues = [];
                var messageLimitCount = 5;
                var selectedData;
                var hasCommandMessage = false;

                // 재귀호출
                var commandMessageFind = function (columns) {
                    for (var i = 0; i < columns.length; i++) {
                        if (columns[i].hasOwnProperty('commandMessage') && columns[i]['commandMessage'] == 'select') {
                            targetColumnKeys.push(columns[i]['key']);
                            hasCommandMessage = true;
                        }

                        if (columns[i].hasOwnProperty('columns')) {
                            commandMessageFind(columns[i]['columns']);
                        }
                    }
                }
              
                commandMessageFind(columns);

                if (hasCommandMessage) {
                    for (var i = 0; i < selectedCount; i++) {
                        if (i > (messageLimitCount - 1)) {
                            break;
                        }

                        targetValue = '';

                        for (var j = 0; j < targetColumnKeys.length; j++) {
                            selectedData = obj.getData('selected')[i][targetColumnKeys[j]];

                            if (ax5.util.isNothing(selectedData)) {
                                selectedData = '';
                            }

                            if (j > 0 && !ax5.util.isNothing(selectedData)) {
                                targetValue += ', ';
                            }

                            targetValue += selectedData;
                        }

                        targetColumnValues.push(targetValue);
                    }
                }
            }

            message = rtnMessage +  '선택된 <font color="red"><b>' + selectedCount + '</b></font> 개의 항목을 등록하시겠습니까?';

            for (var i = 0; i < targetColumnValues.length; i++) {
                message += '<br />';
                message += '[' + targetColumnValues[i] + ']';
            }

            if (hasCommandMessage && (selectedCount - messageLimitCount) > 0) {
                message += '<br />';
                message += '외 <font color="red"><b>' + (selectedCount - messageLimitCount) + '</b></font> 개';
            }

            axDialog.confirm({
                theme : 'danger',
                title : '알림!',
                msg   : message,
                onStateChanged: function () {
                    if (this.state === 'open') {
                        mask.open({theme: 'danger'});
                    }
                    else if (this.state === 'close') {
                        mask.close();
                    }
                }
            }, function () {
                if (this.key == 'ok') {
                    for (var i = (list.length - 1); i >= 0 ; i--) {
                        if (axboot.util.isSelectedRow(list[i])) {
                            list[i]['rowState'] = 'S';
                            commandList.push(list[i]);
                        }
                    }

                    if (commandList.length > 0) {
                        ajaxConfig['data'] = commandList;

                        axboot.ajax({
                            url      : ajaxConfig['url'],
                            data     : JSON.stringify(ajaxConfig['data']),
                            callback : callback
                        });
                    }
                }
            });
        }
    }
};
